module.exports = __webpack_public_path__ + "static/media/paske-3.e7b3afcb.jpg";